module.exports = __webpack_public_path__ + "static/media/logo.5af439ad.png";